import CategoriesBlock from './categories-block';
export default CategoriesBlock;